<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';
import PromoSteps from '@/pages/promotions/promoSteps/Promo-steps.vue';
import PromoTexts from '@/pages/promotions/promoTexts/Promo-texts.vue';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';

const b = bem('promo-template');

const STEPS = [
  {
    label: 'Banner - Step 1',
    value: 'Step 1',
  },
  {
    label: 'Banner - Step 2',
    value: 'Step 2',
  },
  {
    label: 'Banner - Step 3',
    value: 'Step 3',
  },
];

export default {
  components: { PromoTexts, PromoSteps },
  props: {
    hideModal: {
      type: Function,
      required: true,
    },
    promoTemplateChecked: {
      type: Object,
    },
  },
  data() {
    return {
      title: 'Create new',
      checkedStep: 'Step 1',
      checkedStepValues: {
        desktopImage: [],
        mobileImage: [],
        title: '',
        subtitle: '',
        body: '',
        buttonText: '',
        disclaimerText: '',
        hideStep: true,
        textBox1: '',
        textBox2: '',
      },
      isDisabledStep: false,
      optionSteps: STEPS,
      template: {
        name: '',
        banner: {
          text: '',
          mobileDropDownText: '',
          dropDownText: '',
          countDown: true,
          countDownText: '',
        },
        steps: [
          {
            name: 'Step 1',
            desktopImage: '',
            mobileImage: '',
            title: '',
            subtitle: '',
            body: '',
            buttonText: '',
            disclaimerText: '',
            hideStep: true,
            textBox1: '',
            textBox2: '',
          },
          {
            name: 'Step 2',
            desktopImage: '',
            mobileImage: '',
            title: '',
            subtitle: '',
            body: '',
            buttonText: '',
            disclaimerText: '',
            hideStep: true,
            textBox1: '',
            textBox2: '',
          },
          {
            name: 'Step 3',
            desktopImage: '',
            mobileImage: '',
            title: '',
            subtitle: '',
            body: '',
            buttonText: '',
            disclaimerText: '',
            hideStep: true,
            textBox1: '',
            textBox2: '',
          },
        ],
      },
      errors: {
        desktopImage: false,
        mobileImage: false,
        title: false,
        subtitle: false,
        body: false,
        // buttonText: false,
        disclaimerText: false,
      },
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      createPromoTemplatesAction: 'promotions/createPromoTemplates',
      editPromoTemplatesAction: 'promotions/editPromoTemplates',
    }),
    async handleOk() {
      const stepsImages = this.template.steps
        .reduce((acc, step) => [...acc, step.desktopImage, step.mobileImage], []);

      const uploadedImages = await Promise.all(stepsImages.map(async (image) => {
        if (image && image?.file) {
          const formData = new FormData();
          formData.append('file', image.file);
          formData.append('folder', 'default');
          return apiCall({
            type: 'POST',
            headers: { 'content-type': 'multipart/form-data' },
            url: URLS.fileUpload,
            body: formData,
            isToken: true,
          });
        }
        return { data: { data: { url: image?.url || (typeof image === 'string' ? image : '') } } };
      }));

      this.template.steps = this.template.steps.map((step, index) => {
        if (index === 0) {
          return {
            ...step,
            desktopImage: uploadedImages[0].data.data.url,
            mobileImage: uploadedImages[1].data.data.url,
          };
        }
        if (index === 1) {
          return {
            ...step,
            desktopImage: uploadedImages[2].data.data.url,
            mobileImage: uploadedImages[3].data.data.url,
          };
        }
        return {
          ...step,
          desktopImage: uploadedImages[4].data.data.url,
          mobileImage: uploadedImages[5].data.data.url,
        };
      });

      if (this.promoTemplateChecked) {
        const payload = {
          id: this.template.id,
          bannerId: this.template.banner.id,
          template: {
            ...this.template,
            steps: this.template.steps.map((item) => {
              const newItem = {
                ...item,
              };
              delete newItem.templateId;
              delete newItem.addedAt;
              delete newItem.updatedAt;
              return newItem;
            }),
          },
        };
        this.editPromoTemplatesAction(payload);
      } else {
        const payload = {
          name: this.template.name,
          css: {},
          banner: this.template.banner,
          steps: this.template.steps.map((item) => ({
            ...item,
          })),
        };
        if (!payload.banner.countDown) {
          delete payload.banner.countDownText;
        }
        this.createPromoTemplatesAction(payload);
      }
      this.hideModal();
    },
  },
  mounted() {
    if (this.promoTemplateChecked && this.promoTemplateChecked.length) {
      this.title = 'Edit';
      this.template = { ...JSON.parse(JSON.stringify(this.promoTemplateChecked))[0] };
      this.template = {
        ...this.template,
        steps: this.template.steps.sort((a, c) => a.id - c.id),
      };
      this.checkedStepValues = {
        desktopImage: this.template.steps[0].desktopImage
          ? [this.template.steps[0].desktopImage] : [],
        mobileImage: this.template.steps[0].mobileImage
          ? [this.template.steps[0].mobileImage] : [],
        title: this.template.steps[0].title,
        subtitle: this.template.steps[0].subtitle,
        body: this.template.steps[0].body,
        buttonText: this.template.steps[0].buttonText,
        disclaimerText: this.template.steps[0].disclaimerText,
        hideStep: this.template.steps[0].hideStep,
        textBox1: this.template.steps[0].textBox1,
        textBox2: this.template.steps[0].textBox2,
      };
    }
  },
  watch: {
    checkedStep(newV) {
      this.isDisabledStep = true;
      if (newV) {
        const step = this.template.steps.filter((item) => item.name === newV)[0];
        this.checkedStepValues = {
          desktopImage: step.desktopImage.length ? [step.desktopImage] : [],
          mobileImage: step.mobileImage.length ? [step.mobileImage] : [],
          title: step.title,
          subtitle: step.subtitle,
          body: step.body,
          buttonText: step.buttonText,
          disclaimerText: step.disclaimerText,
          hideStep: step.hideStep,
          textBox1: step.textBox1,
          textBox2: step.textBox2,
        };
      }
    },
    checkedStepValues: {
      handler(newV) {
        if (newV.hideStep) {
          this.isDisabledStep = false;
          this.template.steps.filter((item) => item.name === this.checkedStep)[0] = {
            ...this.template.steps.filter((item) => item.name === this.checkedStep)[0],
            desktopImage: [],
            mobileImage: [],
            title: '',
            subtitle: '',
            body: '',
            buttonText: '',
            disclaimerText: '',
            hideStep: true,
            textBox1: '',
            textBox2: '',
          };
          this.errors = {
            desktopImage: false,
            mobileImage: false,
            title: false,
            subtitle: false,
            body: false,
            // buttonText: false,
            disclaimerText: false,
            textBox1: false,
            textBox2: false,
          };
        } else {
          this.template = {
            ...this.template,
            steps: this.template.steps.map((item) => {
              if (item.name === this.checkedStep) {
                return {
                  ...item,
                  desktopImage: newV.desktopImage && newV.desktopImage.length
                    ? newV.desktopImage[0] : '',
                  mobileImage: newV.mobileImage && newV.mobileImage.length
                    ? newV.mobileImage[0] : '',
                  title: newV.title,
                  subtitle: newV.subtitle,
                  body: newV.body,
                  buttonText: newV.buttonText,
                  disclaimerText: newV.disclaimerText,
                  hideStep: newV.hideStep,
                  textBox1: newV.textBox1,
                  textBox2: newV.textBox2,
                };
              }
              return item;
            }),
          };
          this.errors = Object.entries(this.checkedStepValues).reduce((acc, [key, value]) => ({
            ...acc,
            [key]: value && value.length ? !value.length : true,
          }), {});
          delete this.errors.hideStep;
          if (!Object.values(this.errors).includes(true)) {
            this.isDisabledStep = false;
          } else {
            this.isDisabledStep = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<template>
  <h1 class="text-2xl font-bold mb-2">
    {{ title }} promo template.
  </h1>
  <div :class="b('row')">
    <div :class="b('column')">
      <h4>Template name: </h4>
      <a-input
          v-model:value="template.name"
          placeholder="Enter template's name"
          :class="b('input')"
      />
    </div>
  </div>
  <PromoTexts
      v-model:banner-text="template.banner.text"
      v-model:mobile-banner-text="template.banner.mobileDropDownText"
      v-model:drop-down-text="template.banner.dropDownText"
      v-model:count-down-text="template.banner.countDownText"
      v-model:count-down="template.banner.countDown"
  />
  <a-divider />
  <Promo-steps
    :option-steps="optionSteps"
    :is-disabled-step="isDisabledStep"
    v-model:checked-step="checkedStep"
    v-model:checkedStepValues="checkedStepValues"
    :errors="errors"
  />
  <div :class="b('row', { center: true })">
    <a-button
        type="primary"
        html-type="button"
        @click="handleOk()"
    >
      Save
    </a-button>
  </div>
</template>

<style scoped lang="scss">
.promo-template {
  &__row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    align-items: baseline;

    &_center {
      justify-content: center;
    }
  }

  &__column {
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  &__error {
    color: red;
  }
}
</style>
